// T-076 — apertura del modal "Prenota una call" che già esiste sul sito web.
// Su Capacitor nativo apriamo via Capacitor Browser (in-app, niente exit
// dell'app verso Chrome). Su web/PWA fallback a `window.open`.
//
// Il sito (landing/assets/booking.js) gestisce slot disponibili via le edge
// function Supabase pubbliche `booking-slots` e `booking-create`
// (verify_jwt=false), quindi non serve passare token né duplicare la logica
// dentro l'app — riusiamo il pulsante della landing.

const BOOKING_URL = 'https://trackeat.eu/#prenota';

export async function openBookingPage(): Promise<void> {
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor.isNativePlatform()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url: BOOKING_URL, presentationStyle: 'popover' });
      return;
    }
  } catch {
    // Pacchetti Capacitor non disponibili in build web: cadiamo sul fallback.
  }
  window.open(BOOKING_URL, '_blank', 'noopener,noreferrer');
}
